import Cookies from 'js-cookie';
import { FastApiAxiosInstance } from './axiosInstances';

const dccServer = {
  getResultJSON(uuid) {
    return FastApiAxiosInstance.get('/api/v1/version/getDCCResult', {
      params: {
        versionId: uuid,
      },
    });
  },
};

export default dccServer;
